export const ANIMATION_DURATION = 50;
